import { Range } from '@shopify/polaris';
import { defaultLocale } from '../constant';

export const subtractDate = (time: number, date?: Date) =>
  new Date((date ?? new Date()).getTime() - time);

export const dateTimeZoneShort = () => {
  const dateFormatted = new Date().toLocaleDateString(undefined, {
    timeZoneName: 'short',
  });
  return dateFormatted.split(' ').pop() ?? '';
};

export const formatDate = (date: Date) =>
  date.toLocaleString(defaultLocale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

export const formatDateTime = (date: Date) => {
  const formattedDate = date.toLocaleString(defaultLocale, {
    day: '2-digit',
    hour: '2-digit',
    hour12: true,
    minute: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  const [dayMonth, year, time] = formattedDate.split(',');
  return {
    date: [dayMonth, year].join(','),
    time,
  };
};

export const addDateTime = (params: {
  date?: Date;
  days?: number;
  hours?: number;
  minutes?: number;
}) => {
  const { date = new Date(), days, hours, minutes } = params;
  let dateTime = date.getTime();

  if (minutes) {
    dateTime = dateTime + 60000 * minutes;
  }

  if (hours) {
    dateTime = dateTime + 3600000 * hours;
  }

  if (days) {
    dateTime = dateTime + 86400000 * days;
  }

  return new Date(dateTime);
};

export const dayStart = (date?: Date) => {
  const day = date ?? new Date();
  day.setHours(0, 0, 0, 0);
  return day;
};

export const dayEnd = (date?: Date) => {
  const day = date ?? new Date();
  day.setHours(23, 59, 59, 999);
  return day;
};

export const endOfMonth = (dateOrString: Date | string): Date => {
  const date = new Date(
    typeof dateOrString === 'string' ? dateOrString : dateOrString.getTime(),
  );
  return new Date(
    date.getFullYear(),
    date.getMonth() + 1,
    0, // sets to last day of previous month,
    23,
    59,
    59,
    999,
  );
};

export const isValidDate = (value: string, regex = /^\d{2}\/\d{2}\/\d{4}$/g) =>
  regex.test(value) && !isNaN(new Date(value).getTime());

export const isValidTime = (value: string) =>
  !isNaN(Date.parse(`${new Date().toDateString()} ${value}`));

export const getQuarter = (date = new Date()) =>
  Math.floor(date.getMonth() / 3 + 1);

export const lastDaysToRange = (params: {
  date?: Date;
  days: number;
}): Range => {
  const { date = new Date(), days } = params;
  const end = addDateTime({ date, days: -1 });
  return {
    end,
    start: addDateTime({
      date: end,
      days: 1 - days,
    }),
  };
};
